<!-- <h2 mat-dialog-title>Edit Settings</h2>
<div mat-dialog-content>
  <table>
    <tr>
      <td>Green Value:</td>
      <td><input type="text" [(ngModel)]="data.green"></td>
    </tr>
    <tr>
      <td>Yellow Value:</td>
      <td><input type="text" [(ngModel)]="data.yellow"></td>
    </tr>
    <tr>
      <td>Red Value:</td>
      <td><input type="text" [(ngModel)]="data.red"></td>
    </tr>
    <tr>
      <td>Range High:</td>
      <td><input type="text" [(ngModel)]="data.max_value"></td>
    </tr>
    <tr>
      <td>Range Low:</td>
      <td><input type="text" [(ngModel)]="data.min_value"></td>
    </tr>
  </table>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onSave()">Save</button>
  <button mat-button (click)="onClose()">Close</button>
</div> -->
  
  <div class="sensor_threshold_popup" style="overflow-y:hidden">
    
      <div *ngIf="loading" class="loading-container">
        <img src="./assets/chart_loader.gif" alt="Loading...">
      </div>
      <div *ngIf="!loading">
        <div class="modal-header">
          <h4 class="modal-title">Sensor Threshold Value</h4>
        </div>
    
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Sensor Group</th>
                  <th>Range</th>
                  <th>Green</th>
                  <th>Yellow</th>
                  <th>Red</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of data">
                  <td>{{item.metric_type}}</td>
                  <td>
                    <div class="flexnalign">
                      <div class="input-group width_70 m_r_10">
                        <input type="hidden" [(ngModel)]="item.id" class="form-control"/>
                        <input type="text" [(ngModel)]="item.base_value" class="form-control" placeholder="Min"/>
                      </div>
                      <div class="input-group width_70">
                        <input type="text" [(ngModel)]="item.max_value" class="form-control" placeholder="Max"/>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.threshold_1" class="form-control"/>
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="flexnalign">
                      <div class="input-group width_100">
                        <input type="text" [(ngModel)]="item.threshold_2" class="form-control"/>
                        <div class="input-group-append">
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.threshold_3" class="form-control"/>
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
              
            </table>
          </div>
         
        </div>
        <div class="modal-footer">
      
            <button mat-raised-button color="primary" (click)="onSave()">Save</button>
            <button mat-stroked-button color="warn" (click)="onClose()">Close</button>
        </div>
      </div>
    
  </div>
  <!---------------  Plant-Dashboard-Comment ------------------------->